import 'react-phone-number-input/style.css';

import { Box, SxProps } from '@modusign/design-system';
import PhoneInput from 'react-phone-number-input';

import labels from './translation.json';

interface InternationalTelephoneInputProps extends SxProps {
  value: string;
  isInvalid?: boolean;
  onChange: (value: string) => void;
}

export default function InternationalTelephoneInput({
  onChange,
  isInvalid,
  value,
  sx,
}: InternationalTelephoneInputProps) {
  return (
    <Box
      px={4}
      py={3}
      sx={{
        boxShadow: 'inset 1px 1px 2px rgb(0 0 0 / 6%)',
        border: '1px solid',
        borderColor: isInvalid ? 'formBorderNegativeBase' : 'formBorderNeutralBase',
        borderRadius: '3px',
        ...sx,
      }}
    >
      <PhoneInput
        autoFormat={false}
        countryCallingCodeEditable={false}
        defaultCountry="KR"
        enableSearch
        international
        labels={labels}
        placeholder="‘-’없이 입력"
        preferredCountries={['kr']}
        value={value}
        onChange={onChange}
      />
    </Box>
  );
}
